export default __webpack_public_path__ + "static/media/referral.6c8f75f3.png";